import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { CategoriesContext } from '../../../App';
import { selectImage } from '../../../util/misc';
import DownloadCatalogBtn from './elements/download-catalog-btn';

function NewItkHome() {
    const { categories } = useContext(CategoriesContext);

    return (
        <div className="catalog__content">
            <div className="catalog-nav">
                <DownloadCatalogBtn />
            </div>
            <div className="products-catalog production">
                <div className="production-grid">
                    {categories[0]?.children?.map((cat, idx) => {
                        const imageUrl = selectImage(cat.imageVariants, 400, 200, cat.imageUrl);
                        return (
                            <div key={cat.slug} className={`production-grid__item item-${(idx + 1) % 7}`}>
                                <picture>
                                    <source srcSet={imageUrl} media="(max-width: 991px)" />
                                    <img className="production-grid__item-bg" src={imageUrl} alt={cat.name} />
                                </picture>
                                <ul
                                    className="production-grid__list"
                                    style={{ width: '342px', height: '64px' }}
                                >
                                    <Link to={cat.url} className="production-grid__name">
                                        {cat.name}
                                    </Link>
                                    {cat.children?.map((subcat) => (
                                        <li key={subcat.slug} className="production-grid__list-item">
                                            <div className="production-grid__icon-cont">
                                                <svg
                                                    className="icon"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="#000"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                >
                                                    <path d="M4 12h16M14 6l6 6-6 6" />
                                                </svg>
                                            </div>
                                            <Link to={subcat.url}>
                                                <span className="link">{subcat.name}</span>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default NewItkHome;
